import {call, takeLeading} from 'redux-saga/effects'

import {API} from '../../networking/http'
import {PayloadType, setEntityForPayRequestAction} from './actions'

export type resType = {
  status: number
  data?: {
    message?: string
  }
}

export function* setEntityForPayRequest(action: PayloadType) {
  try {
    const {collection, venueId, userId, entityId, successCallback} = action
    const endpoint = 'payments/entityForPay'
    const options = {
      collection,
      draft: {userId, venueId},
      entityId,
    }
    // eslint-disable-next-line
    const res: resType = yield call<typeof API['post']>(API.post, endpoint, options)
    if (res.status === 200) {
      if (typeof successCallback === 'function') {
        successCallback()
      }
    }
  } catch (e: unknown) {
    console.log(e)
  }
}

export function* userWatcherSaga() {
  yield takeLeading(setEntityForPayRequestAction, function* (action) {
    yield setEntityForPayRequest(action.payload)
  })
}
